export const CACHE_EXPIRATION_TIME = 0;
export const CACHE_EXPIRATION_TIME_REFERENCE_BOOK = 10000;

export const DEFAULT_PAGE = 1;

export const DEFAULT_PAGE_SIZE = 50;
